// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1gsFR","label":"CategoryService_label__2fc91","location":"CategoryService_location__12nVZ"};